import React, { useEffect } from "react";
import "./BlogDetail6.css";
import { FaFacebookF, FaLinkedinIn,  FaInstagram } from "react-icons/fa";
import blogBg from "../../assets/images/data6.jpg"; // final bg for info section
import extraImg from "../../assets/images/new1.jpg"; // enquiry left image

const BlogDetail6 = () => {
  // ========= UPDATED SCROLL ANIMATION FUNCTIONALITY (REPEATABLE) ==========
  useEffect(() => {
    // Define the custom animation classes to observe
    // This list ensures all new animated elements are targeted.
    const classesToObserve = [
      ".slide-in-left-fast",
      ".slide-in-top-smooth",
      ".slide-in-right-subtle",
      ".slide-in-left",
    ];

    const elements = document.querySelectorAll(classesToObserve.join(", "));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            // Remove 'active' when out of view to re-trigger the animation (repeatable animation)
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 } // Animation starts when 20% of element is visible
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []); // Run once on mount

  return (
    <>
      {/* ============================================ HERO SECTION ========================================================= */}
      {/* Removed scroll-reveal class from section, only applying animation to overlay */}
      <section
        className="blog-hero-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        {/* HERO OVERLAY: Left से fast स्लाइड-इन (slide-in-left-fast) */}
        <div className="blog-hero-overlay slide-in-left-fast">
          <span className="blog-category">Blog, Business, Marketing</span>

          <h1 className="blog-title">
          Tip’s Of Digital Marketing For Small Businesses
          </h1>

          <div className="blog-meta">
            <p>
              <i className="fa-solid fa-calendar"></i> March 14, 2024
            </p>
            <p>
              <i className="fa-solid fa-comments"></i> No Comments
            </p>
          </div>
        </div>
      </section>

      {/* =============================================== ENQUIRY + NEWSLETTER SECTION======================================== ================= */}
      {/* ENQUIRY SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
      <section className="enquiry-section slide-in-top-smooth">
        {/* LEFT IMAGE */}
        <div
          className="enquiry-left"
          style={{ backgroundImage: `url(${extraImg})` }}
        />

        {/* RIGHT FORM */}
        <div className="enquiry-right">
          <h2 className="enquiry-title">Newsletter</h2>
          <p className="enquiry-text">
            Get free tips and resources right in your inbox, along with 10,000+
            others
          </p>

          <form className="enquiry-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <button type="submit">Sign Up</button>
          </form>
        </div>
      </section>

      {/* ================================================ INFO SECTION================================================ ================= */}
      {/* Removed scroll-reveal class from section, only applying animation to content */}
      <section
        className="info-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        <div className="info-overlay"></div>
        {/* INFO CONTENT: Right से हल्का स्लाइड-इन (slide-in-right-subtle) */}
        <div className="info-content slide-in-right-subtle">
          <h2 className="info-heading">Empowering Data-Driven Decisions</h2>

       
          <p>
          In today’s fast-paced digital world, businesses must adapt to ever-changing technologies and strategies to stay competitive. Whether you are a budding startup or a well-established enterprise, harnessing the power of digital solutions is essential for sustained growth. NMD Infotech is your ultimate partner in navigating this dynamic landscape. With a comprehensive suite of services—digital marketing, website and app development, data analysis, IT consulting, and business development consulting—NMD Infotech provides everything you need to elevate your business to new heights. Let’s delve into how our services can transform your business and unlock its full potential.
          </p>
        </div>
      </section>


   {/* ============================================ LATEST POSTS SECTION =============================================================== */}
<section className="latest-posts-section slide-in-top-smooth">
  <div className="latest-posts-container">

    {/* LEFT SIDE — FULL CONTENT */}
    <div className="posts-left-content slide-in-left">

      {/* ⭐ NEW CONTENT ADDED (Digital Marketing Insights) ⭐ */}
      <h2>Digital Marketing Insights</h2>

      <p>
        However, while acknowledging the significance of digital marketing in today’s 
        business landscape, it’s important to recognize that not everyone is inclined 
        to switch professions and become marketing experts. Nonetheless, understanding 
        the fundamentals of digital marketing can be immensely beneficial, especially 
        for small business owners and individuals seeking to attract and engage clients.
      </p>

      <p>
        Digital marketing has undergone rapid evolution, emerging as a vital aspect 
        of modern marketing strategies. Its transformative impact has revolutionized 
        the way businesses operate and pursue their marketing goals. Small businesses, 
        in particular, stand to benefit greatly from the opportunities afforded by 
        digital marketing, as it enables them to expand their reach and tap into global 
        markets like never before.
      </p>

      <p>
        In essence, digital marketing has become indispensable for businesses of all sizes, 
        offering unparalleled potential for growth and engagement. While becoming a marketing 
        expert may not be everyone’s aspiration, acquiring a basic understanding of digital 
        marketing principles can empower individuals and businesses alike to leverage its 
        advantages effectively.
      </p>

      <p>
        Whether it’s through social media, email campaigns, or search engine optimization, 
        mastering the essentials of digital marketing is essential for staying competitive 
        in today’s dynamic marketplace.
      </p>

      {/* ⭐ SUB HEADING (What is Digital Marketing?) ⭐ */}
      <h2>What is Digital Marketing?</h2>

      <p>
        Digital marketing entails leveraging various online platforms and digital channels, 
        such as websites, social media platforms, email, messaging apps, and more, to promote 
        and advertise your products or services to your intended audience.
      </p>

      <p>
        Through digital marketing, businesses can engage with their target market via platforms 
        like Facebook and Instagram, where they can share content, interact with followers, and 
        run targeted advertising campaigns. Additionally, email marketing allows for direct 
        communication with potential customers, while optimizing for search engines like Google 
        helps ensure high visibility and ranking in search results.
      </p>

      <p>
        Overall, digital marketing offers a versatile toolkit for businesses to connect with 
        their audience, drive engagement, and achieve their marketing objectives effectively.
      </p>

      {/* ⭐ SUB HEADING (Techniques You Can Use) ⭐ */}
      <h2>Techniques You Can Use</h2>

      <ul className="dm-techniques-list">
        <li>Search Engine Optimization (SEO)</li>
        <li>Content Marketing</li>
        <li>Social Media Marketing (SMM)</li>
        <li>Email Marketing</li>
        <li>Google Ads</li>
        <li>Online Reputation Management (ORM)</li>
      </ul>

      {/* ⭐ EXISTING CONTENT (Kept as it is) ⭐ */}
      <h2>Digital Marketing Essentials</h2>

      <p>
        <strong>Understand Your Audience:</strong> Know your target audience inside out. 
        This includes demographics, interests, pain points, and online behavior. Use tools 
        like Google Analytics, social media insights, and customer surveys to gather this data.
      </p>

      <p>
        <strong>Set Clear Goals:</strong> Define specific, measurable, achievable, relevant, 
        and time-bound (SMART) goals for your digital marketing efforts.
      </p>

      <p>
        <strong>Create Quality Content:</strong> Content is king in digital marketing. 
        Develop high-quality, relevant, and engaging content that resonates with your target audience.
      </p>

      {/* Old Transformation Section (As it is) */}
      <h2>Transformation in Marketing</h2>

      <p>
        Over time, technology has undergone exponential growth, leading to a significant 
        transformation in marketing practices from conventional methods to more innovative approaches.
      </p>

      <p>
        Although traditional marketing still holds relevance, the ascendancy of digital marketing 
        has attracted a larger pool of businesses. Understanding the distinction between 
        traditional and digital marketing is crucial.
      </p>

      <p>
        This understanding enables them to tailor their strategies effectively based on factors 
        such as the product, target audience, and budget.
      </p>

      <p>
        We will conduct an in-depth comparison between digital and conventional marketing to help 
        you choose the most suitable marketing channel for your brand.
      </p>

    </div>


    {/* RIGHT SIDE — LATEST POSTS LIST (UNCHANGED) */}
    <div className="posts-list slide-in-right-subtle">
      <h2 className="posts-heading">Latest Posts</h2>

      <div className="post-item">
        <img src={require("../../assets/images/post1.png")} alt="Data Science" />
        <div className="post-info">
          <h3>Data Science</h3>
          <p>From Numbers to Knowledge: The Art of Data Science</p>
          <span>16 December 2024</span>
        </div>
      </div>

      <div className="post-item">
        <img src={require("../../assets/images/post2.png")} alt="Empower Your Business" />
        <div className="post-info">
          <h3>Empower Your Business with NMD Infotech’s Data Analytics Services</h3>
          <span>16 December 2024</span>
        </div>
      </div>

      <div className="post-item">
        <img src={require("../../assets/images/post3.png")} alt="NMD Infotech Services" />
        <div className="post-info">
          <h3>NMD Infotech Services</h3>
          <p>Unlocking Business Potential with Data</p>
          <span>12 December 2024</span>
        </div>
      </div>

      <div className="post-item">
        <img src={require("../../assets/images/post4.png")} alt="Digital Marketing vs Traditional" />
        <div className="post-info">
          <h3>Digital Marketing vs Traditional Marketing</h3>
          <span>31 March 2024</span>
        </div>
      </div>

      <div className="post-item">
        <img src={require("../../assets/images/post5.png")} alt="Tips for Digital Marketing" />
        <div className="post-info">
          <h3>Tips for Digital Marketing</h3>
          <span>27 March 2024</span>
        </div>
      </div>

      <div className="post-item">
        <img src={require("../../assets/images/post6.png")} alt="Small Business Marketing" />
        <div className="post-info">
          <h3>Tip’s Of Digital Marketing For Small Business</h3>
          <span>March 2014</span>
        </div>
      </div>

    </div>
  </div>
</section>



   
  
      {/* POST COMMENT SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
<section className="share-comment-section slide-in-top-smooth">

{/* SHARE BOX */}
<div className="share-box">
  <h3>Share it:</h3>

  <div className="share-icons">
  <a href="https://www.facebook.com/digitalmarketingnmd?mibextid=2JQ9oc" className="icon fb"><FaFacebookF /></a>
            <a href="https://www.instagram.com/nmdinfotech/?igsh=M2lnM205YXZ6b3lp#" className="icon tw"><FaInstagram /></a>
            <a href="https://in.linkedin.com/company/nmd-infotech" className="icon ln"><FaLinkedinIn /></a>
  </div>
</div>

{/* COMMENT FORM — Web3Forms Access Key */}
<div className="glass-form">
  <h2>Leave a Reply</h2>
  <p>Your email address will not be published. Required fields are marked *</p>

  <form
    action="https://api.web3forms.com/submit"
    method="POST"
    className="webform3"
  >
    {/* REQUIRED ACCESS KEY */}
    <input type="hidden" name="access_key" value="YOUR_ACCESS_KEY_HERE" />

    {/* Auto Subject */}
    <input type="hidden" name="subject" value="New Blog Comment Submitted" />

    {/* Comment */}
    <label>Comment *</label>
    <textarea name="comment" placeholder="Write your comment..." required></textarea>

    {/* Name */}
    <label>Name *</label>
    <input type="text" name="name" placeholder="Enter your name" required />

    {/* Email */}
    <label>Email *</label>
    <input type="email" name="email" placeholder="Enter your email" required />

    {/* Website */}
    <label>Website</label>
    <input type="text" name="website" placeholder="Your website (optional)" />

    <div className="checkbox-row">
      <input type="checkbox" />
      <span>Save my info for next time.</span>
    </div>

    <button className="submit-btn">Post Comment</button>
  </form>
</div>

</section>
</>
  );
};

export default BlogDetail6;